import { FormikProps } from "formik";
import { LocationFormValues } from "../types";

interface UseLocationFieldHandlersProps {
	formik: FormikProps<LocationFormValues>;
	oceanWeatherIntelligenceStore: any;
}

export function useLocationFieldHandlers({
	formik,
	oceanWeatherIntelligenceStore,
}: UseLocationFieldHandlersProps) {
	const handleChangeRegion = async (value: string) => {
		if (value) {
			formik.setFieldValue("macroRegionId", parseInt(value));
			formik.setFieldValue("stationRegion", undefined);

			oceanWeatherIntelligenceStore.getStationForLocationAPI(parseInt(value));
		}
	};

	const handleChangeStation = async (value: string) => {
		if (value) {
			formik.setFieldValue("stationRegion", value);
		}
	};

	return {
		handleChangeRegion,
		handleChangeStation,
	};
}
